import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'swodoc-node-number',
  templateUrl: 'swodoc-node-number.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwodocNodeNumber {
  @Input()
  node: any;
  @Output()
  changed: EventEmitter<any> = new EventEmitter<any>();

  get text(): string | undefined {
    if (this.node.responses && this.node.responses.length > 0 && this.node.responses[0].value) {
      return this.node.responses[0].value;
    }
  }

  set text(value: string | undefined | null) {
    this._updateText(value);
  }

  _updateText(value: string | undefined | null) {
    if (!value) {
      // Normalize the absence of a value to undefined as
      // the AuditFormulaService is able to handle undefined, but not null or NaN.
      value = undefined;
      this.node.responses = [{ value: value }];
      this.changed.emit(this.node);
      return;
    }
    const valueNoCommas = value.replace(/,/g, '.');
    const valueOnlyNumeric = valueNoCommas.replace(/^(-)|[^0-9.]+/g, '$1');
    this.node.responses = [{ value: valueOnlyNumeric }];
    this.changed.emit(this.node);
  }
}
